// Professional Canadian Trademark Registration Website - Mock Data

export const testimonials = [
  {
    id: 1,
    name: "Dr. Catherine Reynolds",
    location: "Toronto, ON",
    rating: 5,
    text: "Working with this firm demonstrated exceptional professionalism. Their comprehensive approach to CIPO trademark registration ensured our intellectual property was properly protected. The team's expertise in Canadian trademark law is evident in every interaction.",
    business: "Reynolds Medical Group"
  },
  {
    id: 2,
    name: "Michael Bergmann",
    location: "Vancouver, BC",
    rating: 5,
    text: "The thorough preliminary search and strategic filing recommendations prevented costly mistakes. Their knowledge of CIPO procedures and Canadian trademark precedents provided confidence throughout the registration process.",
    business: "Bergmann Technology Inc."
  },
  {
    id: 3,
    name: "Sophie Beaumont",
    location: "Montreal, QC",
    rating: 5,
    text: "Impressive command of both English and French trademark requirements. The detailed analysis and proactive communication set a high standard for professional service. Our brand is now properly secured across all Canadian jurisdictions.",
    business: "Beaumont Pharmaceuticals"
  },
  {
    id: 4,
    name: "James O'Connor",
    location: "Calgary, AB",
    rating: 5,
    text: "The comprehensive trademark portfolio management exceeded expectations. Their strategic approach to multi-class registration and opposition monitoring demonstrates deep expertise in Canadian intellectual property law.",
    business: "O'Connor Energy Solutions"
  },
  {
    id: 5,
    name: "Dr. Priya Sharma",
    location: "Ottawa, ON",
    rating: 5,
    text: "Exceptional attention to detail in documentation and filing procedures. The firm's systematic approach to CIPO requirements and responsive communication throughout the examination process was exemplary.",
    business: "Sharma Research Institute"
  },
  {
    id: 6,
    name: "William MacKenzie",
    location: "Toronto, ON",
    rating: 5,
    text: "Three successful trademark registrations with consistently superior service. Their expertise in navigating complex classification issues and responding to examiner inquiries has been invaluable to our business expansion.",
    business: "MacKenzie Maritime Group"
  },
  {
    id: 7,
    name: "Dr. Angela Chen",
    location: "Markham, ON",
    rating: 5,
    text: "The comprehensive search report identified potential conflicts that would have resulted in application refusal. Their proactive approach and strategic counsel demonstrated thorough understanding of Canadian trademark examination standards.",
    business: "Chen Biotechnology Corp."
  },
  {
    id: 8,
    name: "Robert Fitzgerald",
    location: "Winnipeg, MB",
    rating: 5,
    text: "Professional guidance through complex classification decisions and specimen requirements. Their expertise in CIPO procedures and trademark prosecution strategy resulted in successful registration despite initial examiner objections.",
    business: "Fitzgerald Manufacturing Ltd."
  },
  {
    id: 9,
    name: "Marie Lafontaine",
    location: "Quebec City, QC",
    rating: 5,
    text: "Comprehensive bilingual service with meticulous attention to federal trademark requirements. The firm's systematic approach to documentation and their expertise in responding to office actions ensured efficient processing.",
    business: "Lafontaine Design Studio"
  },
  {
    id: 10,
    name: "David Patterson",
    location: "Edmonton, AB",
    rating: 5,
    text: "After an unsuccessful self-filing attempt, their expertise successfully addressed examiner concerns and secured registration. The strategic amendments and supporting arguments demonstrated exceptional knowledge of Canadian trademark law.",
    business: "Patterson Industrial Solutions"
  },
  {
    id: 11,
    name: "Dr. Linda Wong",
    location: "Richmond, BC",
    rating: 5,
    text: "Thorough consultation process identified optimal protection strategy for our medical practice brand. Their understanding of CIPO examination criteria and professional service standards ensured successful registration.",
    business: "Wong Medical Clinic"
  },
  {
    id: 12,
    name: "Thomas Anderson",
    location: "London, ON",
    rating: 5,
    text: "Proactive communication at every stage of the registration process. The firm's systematic approach to deadline management and their expertise in Canadian trademark procedures provided excellent value for our investment.",
    business: "Anderson Construction Group"
  }
];

export const processSteps = [
  {
    step: 1,
    title: "Comprehensive Assessment",
    description: "Initial evaluation of your trademark application including thorough search of CIPO databases, common law rights analysis, and strategic classification recommendations to optimize protection scope."
  },
  {
    step: 2,
    title: "Professional Filing",
    description: "Expert preparation and submission of your trademark application to the Canadian Intellectual Property Office, ensuring compliance with all federal requirements and strategic positioning for examination."
  },
  {
    step: 3,
    title: "Ongoing Management",
    description: "Continuous monitoring of application status, professional response to examiner inquiries, management of publication period, and coordination of registration certificate issuance."
  }
];

export const formSubmission = (formData) => {
  // Mock form submission - will be replaced with actual API call
  console.log('Form submitted:', formData);
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ success: true, message: 'Thank you for your inquiry. Our team will contact you within one business day.' });
    }, 1000);
  });
};

export const services = [
  {
    id: 'trademark-registration',
    title: 'Trademark Registration (Canada)',
    shortDesc: 'Comprehensive CIPO trademark filing and prosecution services',
    icon: 'Shield',
    link: '/services/trademark-registration'
  },
  {
    id: 'copyright-registration',
    title: 'Copyright Registration',
    shortDesc: 'Federal copyright protection for creative and literary works',
    icon: 'FileText',
    link: '/services/copyright-registration'
  },
  {
    id: 'comprehensive-search',
    title: 'Trademark Comprehensive Search',
    shortDesc: 'Detailed clearance search and registrability analysis',
    icon: 'Search',
    link: '/services/comprehensive-search'
  },
  {
    id: 'company-formation',
    title: 'Company Formation',
    shortDesc: 'Federal and provincial business incorporation services',
    icon: 'Building',
    link: '/services/company-formation'
  },
  {
    id: 'amazon-brand-registry',
    title: 'Amazon Brand Registry',
    shortDesc: 'Amazon marketplace brand protection and enrollment',
    icon: 'Package',
    link: '/services/amazon-brand-registry'
  }
];

export const pricingPlans = [
  {
    name: 'Basic',
    price: 'CAD $60',
    note: '+ CIPO Filing Fee',
    features: [
      'Case Review',
      'Basic Trademark Search',
      'Trademark Monitoring Services (1 Month)',
      'Trademark Secured®',
      'Filing along with your Paperwork'
    ],
    footnote: 'CIPO Filing Fee: $491 CAD per class.',
    recommended: false,
    badge: null
  },
  {
    name: 'Standard',
    price: 'CAD $199',
    note: '+ CIPO Filing Fee',
    features: [
      'Case Review by a (TM Expert)',
      'Basic Free Trademark Search',
      'Trademark Monitoring Services (3 Months)',
      'Trademark Secured®',
      'Refusal Risk Meter®',
      'Filing along with your Paperwork'
    ],
    footnote: 'CIPO Filing Fee: $491 CAD per class.',
    recommended: true,
    badge: 'Recommended'
  },
  {
    name: 'Deluxe',
    price: 'CAD $399',
    note: '+ CIPO Filing Fee',
    features: [
      'Case Review & Filing by an (Attorney)',
      'Expedited Application Processing within 24 Hours',
      'Filing along with Complete Paperwork',
      'Trademark Monitoring Services (12 Months)',
      'Trademark Secured®',
      'Refusal Risk Meter®',
      'Litigant Scan',
      'Comprehensive trademark search report (all 10 provinces & 3 territories + social media/domain)',
      'Cease & Desist Letter',
      'Dedicated Account Manager & 100% Approval Guaranteed'
    ],
    footnote: 'CIPO Filing Fee: $491 CAD per class.',
    recommended: false,
    badge: 'Best Seller'
  }
];
